import Axios from "axios";

var URL = "https://youconnected-f6114d7c794c.herokuapp.com/";
// var URL = "http://localhost:5001/";
// const { REACT_APP_ENV } = process.env;


// if(REACT_APP_ENV === "developer"){
//   URL = "https://lvcu43ajr2.execute-api.us-east-1.amazonaws.com/developer/";
// }


const API = {
  logIn: function (source, userName, password) {
    return Axios.post(
      `${URL}api/login`,
      {
        "email": userName,
        "password": password,
      },
      { cancelToken: source.token }
    );
  },

  postVehicle: function (source, vehicle) {
    return Axios.post(
      `${URL}api/vehicle`,
      vehicle,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  postClient: function (source, client) {
    return Axios.post(
      `${URL}api/client`,
      client,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  removeAudio: function (source, audio_url) {
    return Axios.post(
      `${URL}api/delete/audio`,
      { "url": audio_url },
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  postService: function (source, service) {
    return Axios.post(
      `${URL}api/service`,
      service,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  postServiceStep1: function (source, vehicle, id) {
    return Axios.post(
      `${URL}api/service/step/1`,
      {vehicle: vehicle, service_id: id},
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  postServiceStep2: function (source, user_id, id) {
    return Axios.post(
      `${URL}api/service/step/2`,
      {user_id: user_id, service_id: id},
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getServiceItems: function (source, service_id) {
    return Axios.get(
      `${URL}api/service-items/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getParameters: function (source) {
    let auth = localStorage.getItem('token');
    return Axios.get(
      `${URL}api/parameters`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  requestPart: function (source, payload) {
    return Axios.post(
      `${URL}api/service-items/part-requests`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        cancelToken: source.token,
      }
    );
},

startServiceTracking: function (source, service_id) {
  return Axios.post(
    `${URL}api/services/${service_id}/tracking/start`,
    null,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      cancelToken: source.token,
    }
  );
},

// End service tracking (when Order page closes)
// Regular Axios version (use in normal flows)
endServiceTracking: function (source, service_id) {
  return Axios.post(
    `${URL}api/services/${service_id}/tracking/end`,
    null,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      cancelToken: source.token,
    }
  );
},

  getUsers: function (source) {
    let auth = localStorage.getItem('token');
    return Axios.get(
      `${URL}api/users`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getClientQuote: function (source, service_id, token) {
    return Axios.get(
      `${URL}api/client-quote/${service_id}?token=${token}`,
      { cancelToken: source.token }
    );
  },

  submitClientQuote: function (source, service_id, data) {
    return Axios.post(
      `${URL}api/client-quote/submit/${service_id}?token=${data.token}`,
      {data},
      { cancelToken: source.token }
    );
  },

  rejectClientQuote: function (source, service_id, data) {
    return Axios.post(
      `${URL}api/client-quote/reject/${service_id}`,
      { data },
      { cancelToken: source.token }
    );
  },

  getUser: function (source, user_id) {
    let auth = localStorage.getItem('token');
    return Axios.get(
      `${URL}api/users/${user_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  setPartReceived: function (source, service_parts_id, value) {
    return Axios.put(
      `${URL}api/service-parts/${service_parts_id}/receive`,
      { value: !!value },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        cancelToken: source.token
      }
    );
  },

  setPartInstalled: function (source, service_parts_id, value) {
    return Axios.put(
      `${URL}api/service-parts/${service_parts_id}/install`,
      { value: !!value },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        cancelToken: source.token
      }
    );
  },

  setServiceClosure: function (source, service_id, what, value) {
    // what: 'paid' | 'picked_up'
    return Axios.put(
      `${URL}api/service/${service_id}/closure`,
      { what: what, value: !!value },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        cancelToken: source.token
      }
    );
  },

  serviceTransition: function (source, service_id, action) {
    return Axios.post(
      `${URL}api/service/${service_id}/transition`,
      { action },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        cancelToken: source.token
      }
    );
  },

  getNotifications: function (source, { limit = 50, unread = false } = {}) {
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    if (unread) params.set('unread', '1');
    return Axios.get(
      `${URL}api/notifications?${params.toString()}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        cancelToken: source.token
      }
    );
  },

  getNotificationsUnreadCount: function (source) {
    return Axios.get(
      `${URL}api/notifications/unread-count`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        cancelToken: source.token
      }
    );
  },

  markNotificationRead: function (source, notification_id) {
    return Axios.put(
      `${URL}api/notifications/${notification_id}/read`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        cancelToken: source.token
      }
    );
  },

  markAllNotificationsRead: function (source) {
    return Axios.put(
      `${URL}api/notifications/read-all`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        cancelToken: source.token
      }
    );
  },

  postSubstatus: function (source, service_id, substatus) {
    let auth = localStorage.getItem('token');
    return Axios.put(
      `${URL}api/service-substatus/${service_id}`,
      {"new_substatus": substatus},  // No body needed
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  startServiceItem: function (source, service_item_id) {
    let auth = localStorage.getItem('token');
    return Axios.put(
      `${URL}api/service-item/start/${service_item_id}`,
      {},  // No body needed
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  updateParameters: function (source, valor_homem_hora) {
    let auth = localStorage.getItem('token');
    return Axios.put(
      `${URL}api/parameters`,
      valor_homem_hora,  // No body needed
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  finishServiceItem: function (source, service_item_id) {
    let auth = localStorage.getItem('token');
    return Axios.put(
      `${URL}api/service-item/finish/${service_item_id}`,
      {},  // No body needed
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  finalizeOS: function (source, service_id) {
    return Axios.post(
      `${URL}api/update-service-status`,
      { 'service_id': service_id },
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  postServiceItem: function (source, service, truncate = "NO") {
    if (truncate === "YES") {
      service.truncate = "YES"
    }
    return Axios.post(
      `${URL}api/add-service-items`,
      service,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  putServiceItem: function (source, service, service_id, date, generateOS = "NO", scheduledDate = null) {
    return Axios.put(
      `${URL}api/service-items/update`,
      { service: service, service_id: service_id, date: date, generate_os: generateOS, scheduled_date: scheduledDate },
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  updateUser: function (source, user_id, user) {
    let auth = localStorage.getItem('token');
    return Axios.put(
      `${URL}api/users/${user_id}`,
      {user:user },
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  resetUserPassword: function (source, user_id) {
    return Axios.post(
      `${URL}api/users/${user_id}/reset-password`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  deleteUser: function (source, user_id) {
    return Axios.put(
      `${URL}api/users/delete/${user_id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  getServiceInfo: function (source, service_id) {
    return Axios.get(
      `${URL}api/service-items/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getAllChecklistItems: function (source) {
    return Axios.get(`${URL}api/checklist-items`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getUserChecklistItems: function (source, userId) {
    return Axios.get(`${URL}api/checklist-items/user/${userId}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  addUserChecklistItems: function (source, data) {
    return Axios.post(`${URL}api/checklist-items/user`, data,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  deleteUserChecklistItem: function (source, itemId) {
    let auth = localStorage.getItem('token');
    return Axios.put(`${URL}api/checklist-items/user/item/${itemId}/delete`,
      { },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  addCustomChecklistItem: function (source, data) {
    return Axios.post(`${URL}api/checklist-items/custom`, data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  bulkToggleChecklistItems: function (source, data) {
    return Axios.post(`${URL}api/checklist-items/user/bulk`, data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  getClient: function (source, cpf) {
    return Axios.get(
      `${URL}api/client/${cpf}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getVehicleByService: function (source, service_id) {
    return Axios.get(
      `${URL}api/service/vehicle/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getUserByService: function (source, service_id) {
    return Axios.get(
      `${URL}api/service/user/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getChecklistDetail: function (source, service_id) {
    return Axios.get(
      `${URL}api/service-details/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getChecklistCheckout: function (source, service_id) {
    return Axios.get(
      `${URL}api/checkout/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getServiceTypes: function (source) {
    return Axios.get(
      `${URL}api/service-types`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  addCustomServiceType: function (source, data) {
    return Axios.post(`${URL}api/service-types/custom`, data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  getClients: function (source, cpf) {
    return Axios.get(
      `${URL}api/clients`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getVehicle: function (source, license) {
    return Axios.get(
      `${URL}api/vehicle/${license}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getAddress: function (source, cep) {
    return Axios.get(
      `https://viacep.com.br/ws/${cep}/json/`,
      { cancelToken: source.token }
    );
  },

  getOrder: function (source, id, selected = false) {
    return Axios.get(
      `${URL}api/service-detail/${id}?selected=${selected}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getStatistics: function (source, time_range, month, startDate, endDate) {
    const params = new URLSearchParams();
    if (time_range) params.set('time_range', time_range);
    if (month) params.set('month', month);
    if (startDate) params.set('start_date', startDate);
    if (endDate) params.set('end_date', endDate);
    return Axios.get(
      `${URL}api/statistics?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  getWorkerMetrics: function (source, time_range, month, startDate, endDate) {
    const params = new URLSearchParams();
    if (time_range) params.set('time_range', time_range);
    if (month) params.set('month', month);
    if (startDate) params.set('start_date', startDate);
    if (endDate) params.set('end_date', endDate);
    return Axios.get(
      `${URL}api/executors-summary?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  getServiceStatus: function (source, service_id) {
    return Axios.get(
      `${URL}api/service-status/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getMecUsers: function (source) {
    return Axios.get(
      `${URL}/api/assign-workers`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getPendingApprovals: function (source) {
    return Axios.get(
      `${URL}api/services/pending-approval`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  postBossApproval: function (source, serviceId, action, reason = '') {
    return Axios.post(
      `${URL}api/service/${serviceId}/boss-approval`,
      { action, reason },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  putServiceStatus: function (source, service_id, status) {
    return Axios.put(
      `${URL}api/service-status/${service_id}`,
      { status: status },
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  assignWorker: function (source, service_id, assigned_to) {
    return Axios.post(
      `${URL}api/assign-work`,
      { "service_id": service_id, "assigned_to": assigned_to },
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getServiceMechanics: function (source, service_id) {
    return Axios.get(
      `${URL}api/service-mechanics/${service_id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  removeServiceMechanic: function (source, service_id, user_id) {
    return Axios.delete(
      `${URL}api/service-mechanics/${service_id}/${user_id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token
      }
    );
  },

  postComment: function (source, service_id, observation) {
    return Axios.post(
      `${URL}api/observation`,
      { "service_id": service_id, observation: observation },
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getServices: function (source, status = null) {
    if (status) {
      return Axios.get(
        `${URL}api/services?status=${status}`,
        { 
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          cancelToken: source.token 
        }
      );
    } else {
      return Axios.get(
        `${URL}api/services`,
        { 
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          cancelToken: source.token 
        }
      );
    }
  },

  getChecklistService: function (source, service_id) {
    return Axios.get(
      `${URL}api/service/checklist/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },

  getServiceDetail: function (source, service_id) {
    return Axios.get(
      `${URL}api/service/${service_id}`,
      { 
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        cancelToken: source.token 
      }
    );
  },


    // ---- Appointments ----
    getAppointments: function (source, { start, end, status } = {}) {
      const params = new URLSearchParams();
      if (start) params.append("start", start);   // ISO string: 'YYYY-MM-DDTHH:mm:ss'
      if (end)   params.append("end", end);       // ISO string
      if (status) params.append("status", status); // 'scheduled' | 'completed' | 'cancelled'
  
      const qs = params.toString() ? `?${params.toString()}` : "";
      return Axios.get(
        `${URL}api/appointments${qs}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          cancelToken: source.token
        }
      );
    },
  
    getAppointment: function (source, appointment_id) {
      return Axios.get(
        `${URL}api/appointments/${appointment_id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          cancelToken: source.token
        }
      );
    },
  
    postAppointment: function (source, appointment) {
      // appointment = { client_name, car, description, start_datetime, end_datetime, status? }
      return Axios.post(
        `${URL}api/appointments`,
        appointment,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          cancelToken: source.token
        }
      );
    },
  
    putAppointment: function (source, appointment_id, appointment) {
      // full update (same required fields as POST)
      return Axios.put(
        `${URL}api/appointments/${appointment_id}`,
        appointment,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          cancelToken: source.token
        }
      );
    },
  
    patchAppointment: function (source, appointment_id, patch) {
      // partial update: any subset of { client_name, car, description, start_datetime, end_datetime, status }
      return Axios.patch(
        `${URL}api/appointments/${appointment_id}`,
        patch,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          cancelToken: source.token
        }
      );
    },
  
    deleteAppointment: function (source, appointment_id, { hard = false } = {}) {
      // soft delete by default; hard=true to permanently delete
      return Axios.put(
        `${URL}api/appointments/delete/${appointment_id}?hard=${hard ? "true" : "false"}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          cancelToken: source.token
        }
      );
    },

  cancelToken: function () {
    const cancelToken = Axios.CancelToken;
    return cancelToken.source();
  },
  cancel: function (token) {
    if (token) token.cancel('cancelling');
  }
}

export default API;